import { createEvent, createEffect, sample, EventCallable } from 'effector'
import { GtmEventData, TypedEventPayload } from 'utils/analytics'

class AnalyticsService {
  readonly analyticsHappened: EventCallable<GtmEventData> =
    createEvent<GtmEventData>()

  private readonly sendToGtmFx = createEffect(
    async (eventData: GtmEventData): Promise<void> => {
      window.dataLayer?.push(eventData)
    }
  )

  constructor() {
    sample({
      clock: this.analyticsHappened,
      target: this.sendToGtmFx
    })
  }

  capture = <P extends keyof TypedEventPayload>(
    event: P,
    eventPayload: TypedEventPayload[P]
  ): void => {
    this.analyticsHappened({ event: event, ...eventPayload })
  }
}

export const analyticsService = new AnalyticsService()
